module.exports = __webpack_public_path__ + "img/r6.89576319.svg";